import { ViewMyTickets } from 'ui/profile';

export const ProfileRoutes = {
  viewMyTickets: {
    component: ViewMyTickets,
    path: '/profile/view-my-tickets',
  }
};